import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

import { Layout } from '@app/components/Layout';
import { renderMdxComponents } from '@app/helpers';
import { PRIVACY_POLICY } from '@app/constants/privacy_policy';

import {
  Next,
  Main,
  Title,
  Spacer,
  Target,
  BodyBack,
  HeroSection,
  HeroWrapper,
  MainWrapper,
  FooterSpacer,
  LayoutWrapper,
  ArticleContent,
  MaxWidthWrapper,
  DarkHeaderBackground,
  LightHeaderBackground,
  SneakyHeaderBackground,
} from './policy.styles';

export const Policy: React.FC = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <Layout>
      <Next>
        <BodyBack />
        <LayoutWrapper />
        <HeroWrapper>
          <LightHeaderBackground />
          <SneakyHeaderBackground />
          <HeroSection>
            <MaxWidthWrapper>
              <Title>Privacy Policy</Title>
            </MaxWidthWrapper>
          </HeroSection>
        </HeroWrapper>
        <DarkHeaderBackground />
        <LayoutWrapper>
          <Main>
            <Target />
            <MainWrapper className="main-section">
              <ArticleContent>
                <ReactMarkdown
                  //@ts-ignore
                  components={renderMdxComponents({})}
                >
                  {PRIVACY_POLICY}
                </ReactMarkdown>
                <Spacer />
              </ArticleContent>
            </MainWrapper>
          </Main>
        </LayoutWrapper>

        <Spacer />
        <Spacer />
        <Spacer />
        <FooterSpacer />
      </Next>
    </Layout>
  );
};
